<div *ngIf="reportType === 'Monthwise'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================= HEADER ================= -->
    <table style="width:100%;border-collapse:collapse;border:1px solid black;">
      <tr>
        <th colspan="4" style="border:1px solid black;font-size:18px;font-weight:bold;text-align:center">
          हिंदुस्तान प्रकाशन संस्था
        </th>
        <th colspan="5" style="border:1px solid black;font-size:18px;font-weight:bold;text-align:center">
          Granth Package Registration Ledger Report
        </th>
        <th colspan="3" style="border:1px solid black;font-size:18px;font-weight:bold;text-align:end;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
      <tr>
        <th colspan="4" style="border:1px solid black;font-size:16px;font-weight:bold;text-align:center">
          विवेक पुस्तक प्रकाशन
        </th>
        <th colspan="5" style="border:1px solid black;font-size:16px;font-weight:bold;text-align:center">
          Office Representative Briefly
        </th>
        <th colspan="3" style="border:1px solid black;font-size:16px;font-weight:bold;text-align:end;">
          {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%;border-collapse:collapse;border:1px solid black;font-size:13px;">

      <thead>
        <tr>
          <th style="border:1px solid black;">Book Seller Name</th>
          <th style="border:1px solid black;">Subscriber No</th>
          <th style="border:1px solid black;">Book Name</th>
          <th style="border:1px solid black;">Sale Copies</th>
          <th style="border:1px solid black;">Book Price</th>
          <th style="border:1px solid black;">Net Price</th>
          <th style="border:1px solid black;">Total</th>
          <th style="border:1px solid black;">Paid Amt</th>
          <th style="border:1px solid black;">Unpaid Amt</th>
        </tr>
      </thead>

      <tbody>

        <ng-container *ngFor="let office of groupedOfficeRepData">

          <!-- ===== OFFICE HEADER ===== -->
          <tr>
            <td colspan="9"
              style="border:1px solid black;font-weight:bold;text-align:center;font-size:16px;background-color:#dce6f1;">
              Office Representative : {{ office.office_rep_name || '(No Office)' }}
            </td>
          </tr>

          <ng-container *ngFor="let rep of office.reps">

            <!-- ===== REP HEADER ===== -->
            <tr>
              <td colspan="9" style="border:1px solid black;font-weight:bold;background-color:#f2f2f2;">
                Rep Name : {{ rep.rep_name || '(No Rep)' }}
              </td>
            </tr>

            <!-- ===== DATA ROWS ===== -->
            <tr *ngFor="let row of rep.records">
              <td style="border:1px solid black;">{{ row.book_seller_name }}</td>
              <td style="border:1px solid black;text-align:center;">{{ row.subscribers_no }}</td>
              <td style="border:1px solid black;">{{ row.book_name }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.sale_copies }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.book_price | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.total | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.total_price | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.recipt_amt | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.remaining_amt | number:'1.2-2' }}</td>
            </tr>

            <!-- ===== REP TOTAL ===== -->
            <tr style="font-weight:bold;background-color:#fff2cc;">
              <td colspan="3" style="border:1px solid black;text-align:right;">
                Rep Total ({{ rep.rep_name || 'No Rep' }})
              </td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalSale }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalAmount | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalNet | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalAmount | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalReceived | number:'1.2-2' }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalPending | number:'1.2-2' }}</td>
            </tr>

          </ng-container>

          <!-- ===== OFFICE TOTAL ===== -->
          <tr style="font-weight:bold;">
            <td colspan="3" style="border:1px solid black;text-align:right;background-color:#f4b084;">
              Office Rep Total ({{ office.office_rep_name || 'No Office' }})
            </td>
            <td style="border:1px solid black;text-align:right;background-color:#f4b084;">{{ office.totalSale }}</td>
            <td style="border:1px solid black;text-align:right;background-color:#f4b084;">{{ office.totalAmount | number:'1.2-2' }}</td>
            <td style="border:1px solid black;text-align:right;background-color:#f4b084;">{{ office.totalNet | number:'1.2-2' }}</td>
            <td style="border:1px solid black;text-align:right;background-color:#f4b084;">{{ office.totalAmount | number:'1.2-2' }}</td>
            <td style="border:1px solid black;text-align:right;background-color:#f4b084;">{{ office.totalReceived | number:'1.2-2' }}</td>
            <td style="border:1px solid black;text-align:right;background-color:#f4b084;">{{ office.totalPending | number:'1.2-2' }}</td>
          </tr>

        </ng-container>

      </tbody>

      <!-- ================= GRAND TOTAL ================= -->
      <tfoot>
        <tr style="font-weight:bold;background:#c8753f;color:white;">
          <td colspan="3" style="border:1px solid black;text-align:right;">Grand Total</td>
          <td style="border:1px solid black;text-align:right;">{{ grandCopies }}</td>
          <td style="border:1px solid black;text-align:right;">{{ grandBookPrices | number:'1.2-2' }}</td>
          <td style="border:1px solid black;text-align:right;">{{ grandNet | number:'1.2-2' }}</td>
          <td style="border:1px solid black;text-align:right;">{{ grandAmount | number:'1.2-2' }}</td>
          <td style="border:1px solid black;text-align:right;">{{ grandJama | number:'1.2-2' }}</td>
          <td style="border:1px solid black;text-align:right;">{{ grandYene | number:'1.2-2' }}</td>
        </tr>
      </tfoot>

    </table>
  </div>

  <!-- ================= ACTION BUTTONS ================= -->
  <div class="noPrint d-flex justify-content-end gap-3 px-4 my-3">
    <button class="btn btn-success" (click)="exportExcel('OfficeRepWise')">Export</button>
    <button class="btn btn-primary" (click)="printPage4()">Print</button>
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>